import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ApplicationService } from 'app/services/application.service';
import { AuthWebService } from 'app/services/authweb.service';
import { CarrierService } from 'app/services/carrier.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from "ngx-toastr";
import { CurrencyFormat } from "app/pipes/currencyFormat.pipe";
import { AdminAnnualComplianceService } from 'app/admin-annual-compliance/service/admin-annual-compliance.service';

@Component({
  selector: 'app-processview',
  templateUrl: './processview.component.html',
  styleUrls: ['./processview.component.scss'],
  providers: [CurrencyFormat]
})
export class ProcessviewComponent implements OnInit {

  @Input('ctrlData') ctrlData: any;

  dataCntrl: any = { carrierID:-1, roleId: 0, activityId: 0, permittypeSelected:false, selectedtype:'', disableTypes:false, processStarted:false, currentTab:'', formValid:false, isViewEditControl:false, carrier: {}, application: {}, permit: {}, permittype: {}, vehicles:[],permitTypesDocLinks:[]};

  carrierApproval: boolean = false;
  permitApproval: boolean = false;
  complianceApproval: boolean = false;

  application_id: any;
  role_id: any
  activity_id: any;
  compliancedata: any;

  isLoading: boolean = false;
  message = "Loading application, please wait...";
  canload: boolean = false;

  constructor(
    private carrierService: CarrierService,
    private applicationService: ApplicationService,
    private authWebService: AuthWebService,
    private annualComplianceService: AdminAnnualComplianceService,
    public utility: UtilityServiceService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private msg: ToastrService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.ctrlData = { carrierId: 0, roleId: 0, activityId: 0, isApproval: false, currentActive: 1, action: 0, ctrlAction: 0, xstatus:0, data: {} };
    this.isLoading = true;
    
    this.activateRoute.params.subscribe((params: Params) => {
      this.application_id = params['id'];
      this.role_id = params['role'];
      this.activity_id = params['act'];
    });

    if (this.router.url.indexOf("carrier") > 0) {      
      this.setCarrierApplicationData();
    }else if(this.router.url.indexOf("permit") > 0){
      this.setPermitApplicationData();
    }else if(this.router.url.indexOf("compliance") > 0){
      this.setComplianceApplicationData();
    }

  }

  setCarrierApplicationData(){

    this.carrierApproval = true;
    this.permitApproval = false;
    this.dataCntrl.app_type = 'carrier';
    this.dataCntrl.carrierID = this.application_id;
    this.dataCntrl.role_id = this.role_id;
    this.dataCntrl.activity_id = this.activity_id;
    this.utility.carrierId = this.application_id;
    this.utility.isProcessAccounts = false;
    this.utility.isBtnVisible = false;

    this.ctrlData.carrierId = this.application_id;
    this.ctrlData.roleId = this.role_id;
    this.ctrlData.activityId = this.activity_id;
    this.ctrlData.isApproval = true;
    this.ctrlData.xstatus = 1;
    this.canload = true;
    this.isLoading = false;
  }

  setPermitApplicationData(){
    this.applicationService.getById(this.application_id).subscribe((data:any) =>{
      //Is Duplicate so? 
      //this.isDupApplication = data.permit_type.code == this.authWebService.userData.Configurations.find(x => x.Code == "DupPermitAppCode1").Value;
      console.log(data)
      
      this.dataCntrl.application = data;
      this.dataCntrl.carrierID = data.carrier_id;
      this.dataCntrl.role_id = this.role_id;
      this.dataCntrl.activity_id = this.activity_id;
      this.dataCntrl.permit_type_id=data.permit_type_id;
      this.dataCntrl.permit=data.permits;
      this.dataCntrl.permittype=data.permit_type;
      this.dataCntrl.vehicles=data.vehicle;
      //this.utility.carrierStatusId=data.carrier.status_id;
      this.dataCntrl.currentTab = 'permitype';
      this.carrierApproval = false;
      this.permitApproval = true;
      this.dataCntrl.app_type = 'permit';
      this.utility.permitAppId = this.application_id;
      this.utility.isProcessAccounts = false;
      this.utility.isBtnVisible = true;
      this.ctrlData.isApproval = true;
      this.ctrlData.xstatus = 1;
      this.canload = true;
      this.isLoading = false;
  })
  
  }

  async setComplianceApplicationData(){
  const response = await this.annualComplianceService.viewPermitDetails(this.application_id).toPromise();
  if (response != null) {
    this.compliancedata = response; 
    this.complianceApproval = true;
    this.carrierApproval = false;
    this.permitApproval = false;

    this.dataCntrl.app_type = 'compliance';
    this.dataCntrl.compliance_id = this.application_id;
    this.dataCntrl.Is_duplicate = this.compliancedata.Is_duplicate;
    this.dataCntrl.role_id = this.role_id;
    this.dataCntrl.activity_id = this.activity_id;

    this.ctrlData.carrierId = this.application_id;
    this.ctrlData.compliance_id = this.application_id;
    this.ctrlData.roleId = this.role_id;
    this.ctrlData.activityId = this.activity_id;
    this.ctrlData.isApproval = true;
    this.canload = true;
    this.isLoading = false;
  }

  }
}
